// Booking-funnel events for Google Tag Manager. They are pushed to `window.dataLayer`; GTM triggers listen for the event names.
// No personal data goes in (no phone number, name or e-mail): only the step, the session, the price and the order id.
//
//   booking_page_view      the booking page opened                    { astro_id }
//   proceed_to_payment     "Proceed to Payment" pressed               { value, currency, duration, service, offer_active, logged_in }
//   otp_requested          the code was sent to the visitor           { }
//   otp_verified           the visitor logged in with the code        { }
//   payment_gateway_open   PhonePe is about to open                   { value, currency, duration, service, transaction_id }
//   payment_success        PhonePe confirmed the payment              { value, currency, duration, transaction_id }  (once per order)
//   payment_failed         the payment did not go through             { reason, transaction_id }
const SEEN_KEY = 'bvDataLayerSeen';

export const pushEvent = (event, params = {}) => {
  try {
    window.dataLayer = window.dataLayer || [];
    window.dataLayer.push({ event, ...params });
  } catch (error) {
    // analytics must never get in the way of booking
  }
};

// For events that must count once even when the page is reloaded or revisited (the payment result).
export const pushEventOnce = (event, key, params = {}) => {
  try {
    const seen = JSON.parse(localStorage.getItem(SEEN_KEY) || '[]');
    const id = `${event}:${key}`;
    if (key && seen.includes(id)) return;
    pushEvent(event, params);
    if (key) localStorage.setItem(SEEN_KEY, JSON.stringify([...seen, id].slice(-50)));
  } catch (error) {
    pushEvent(event, params);
  }
};
